import React, { forwardRef } from 'react'
import { useState } from 'react'
import styled from 'styled-components'

interface Props extends React.ComponentProps<'div'> {
  onChangeHover?: (hovered: boolean) => void
}

/**
 * Can be used to determine when the mouse has left the container:
 * after a neat delay of 170ms, the callback is fired, or instantly,
 * if the mouse has entered the container.
 */
const MouseOverableFullyExpandedContainer = forwardRef<HTMLDivElement, Props>(
  ({
    onChangeHover=() => {},
    onMouseEnter=() => {},
    onMouseLeave=() => {},
    ...props
  }, ref) => {
    const [TimeoutInfo] = useState<any>({ id: null })

    const _onMouseEnter = (e:any) => {
      onChangeHover(true)
      clearTimeout(TimeoutInfo.id)

      // Default behavior
      onMouseEnter(e)
    }

    const _onMouseLeave = (e: any) => {
      TimeoutInfo.id = setTimeout(() => onChangeHover(false), 170)

      // Default behavior
      onMouseLeave(e)
    }
    
    return (
      <Base
        {...props}
        onMouseEnter={_onMouseEnter}
        onMouseLeave={_onMouseLeave}
        ref={ref}
      />
    )
  }
)

export default MouseOverableFullyExpandedContainer

const Base = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
